<template>
  <div id="ehs-list-loading" class="vs-con-loading__container">
    <vs-alert :active.sync="showAlert" :icon="'warning'" color="warning"  closable close-icon="close">
       {{ $t('soon_to_expired') | capitalize }}: {{ soonToExpired }}
      </vs-alert>
    <div v-show="hasPermission(['IU EHS VIEW'])" class="mt-6">
      <vx-card noShadow ref="filterCard" :title="$t('filters')" class="user-list-filters mb-8">
        <template slot="actions">
          <feather-icon
            @click="search('ehns.name')"
            icon="FilterIcon"
            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          />
          <feather-icon
            @click="resetFilters"
            icon="TrashIcon"
            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
          />
        </template>
        <div class="vx-row mx-2">
          <div class="vx-col md:w-1/2 w-full">
            <label class="text-sm opacity-75">{{$t('client')}}</label>
            <v-select
              multiple
              v-model="params.client_id"
              :options="clientFilter"
              label="ShortName"
              :reduce="client => client.ClientId"
              v-validate="'required'"
              name="filterClient"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label class="text-sm opacity-75">{{$t('agency')}}</label>
            <v-select
              multiple
              v-model="params.category_id"
              :options="categoryFilter"
              label="name"
              :reduce="category => category.id"
              v-validate="'required'"
              name="filterCategory"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2">
            <label class="text-sm opacity-75">{{$t('status')}}</label>
            <v-select
              multiple
              v-model="params.status_id"
              :options="statusFilterState"
              :reduce="status => status.id"
              label="name"
              v-validate="'required'"
              name="filterStatus"
            />
          </div>
          <div class="vx-col md:w-1/2 w-full mt-2">
            <label class="text-sm opacity-75">{{$tc('type')|capitalize}}</label>
            <v-select
              multiple
              v-model="params.type_id"
              :options="types"
              :reduce="type => type.id"
              label="name"
              name="filterType"
              v-validate="'required'"
            />
          </div>
        </div>
      </vx-card>
      <vx-card noShadow :title="$t('status_compliance_details')">
        <template slot="actions">
          <vs-row>
            <div class="vx-col w-full px-1 mb-4 md:w-1/3" v-if="allowEditing">
              <add-button @click="addEhs"/>
              <!-- <vs-button
                @click="addEhs"
                color="success"
                type="filled"
                class="w-full"
                icon-pack="feather" icon="icon-plus"
                >{{$t('add')}} {{$t('new')}}</vs-button> -->
            </div>
            <div class="vx-col w-full px-1 mb-4"  :class="[allowEditing ? 'md:w-1/3' : 'md:w-1/2']">
              <vs-input
                icon="search"
                :placeholder="$t('search')"
                class="w-full"
                v-model="params.search"
                @keypress.enter="search('ehns.name')" 
                />
            </div>
            <div class="vx-col w-full px-1 mb-4" :class="[allowEditing ? 'md:w-1/3' : 'md:w-1/2 ']">
             <export-button :data="this.params" :url="'ehs/export_csv/aiAtSI1992Wsi1__183W3900ASSD75_9_'" :type="name_report"/>
            </div>
        </vs-row>
        </template>
        <add-ehs :clients="clients" :categories="categories" :frequencies="frequencies"/>
        <update-ehs-expiration :ehs="ehs" />
        <pdf-viewer />
        <vs-row >
           <div class="vx-col w-full">
          <vs-table stripe class="fixedHead text-left w-full" :data="ehsList">
            <!-- filteredData -->
            <template slot="thead">
              <th width="200px" @click="search('Cl.ClientName'),sortBy('Cl.ClientName')">
                {{$t('client')}}
                <span
                  v-if="this.sortOrders['Cl.ClientName']== 1"
                  class="material-icons sm-size"
                >keyboard_arrow_up</span>
                <span v-else class="material-icons sm-size">keyboard_arrow_down</span>
              </th>
              <th
                width="300px"
                @click="search('Category.name'),sortBy('Category.name')"
                class="text-left"
              >
                {{$t('agency')}}
                <span
                  v-if="this.sortOrders['Category.name']== 1"
                  class="material-icons sm-size"
                >keyboard_arrow_up</span>
                <span v-else class="material-icons sm-size">keyboard_arrow_down</span>
              </th>

              <th width="100px" class="text-left">{{$tc('type')|capitalize}}</th>
              <th
                width="250px"
                @click="search('ehns.building_number'),sortBy('ehns.building_number')"
              >
                {{$t('building_number')}}
                <span
                  v-if="this.sortOrders['ehns.building_number']== 1"
                  class="material-icons sm-size"
                >keyboard_arrow_up</span>
                <span v-else class="material-icons sm-size">keyboard_arrow_down</span>
              </th>
              <th width="300px" @click="search('ehns.name'),sortBy('ehns.name')">
                {{$t('name')}}
                <span
                  v-if="this.sortOrders['ehns.name']== 1"
                  class="material-icons sm-size"
                >keyboard_arrow_up</span>
                <span v-else class="material-icons sm-size">keyboard_arrow_down</span>
              </th>
              <th
                width="200px"
                class="text-center"
                @click="search('Status.id'),sortBy('Status.id')"
              >
                {{$t('status')}}
                <span
                  v-if="this.sortOrders['Status.id']== 1"
                  class="material-icons sm-size"
                >keyboard_arrow_up</span>
                <span v-else class="material-icons sm-size">keyboard_arrow_down</span>
              </th>
              <th width="300px">{{$t('comments')}}</th>
              <th
                width="120px"
                @click="search('ehns.date_expiration'),sortBy('ehns.date_expiration')"
              >
                {{$t('expiration')}}
                <span
                  v-if="this.sortOrders['ehns.date_expiration']== 1"
                  class="material-icons sm-size"
                >keyboard_arrow_up</span>
                <span v-else class="material-icons sm-size">keyboard_arrow_down</span>
              </th>
              <th
                width="150px"
                @click="search('ehns.date_expedition'),sortBy('ehns.date_expedition')"
              >
                {{$t('start')}}
                <span
                  v-if="this.sortOrders['ehns.date_expedition']== 1"
                  class="material-icons sm-size"
                >keyboard_arrow_up</span>
                <span v-else class="material-icons sm-size">keyboard_arrow_down</span>
              </th>
              <th width="100px">{{$t('duration')}} ({{$t('days')}})</th>
              <th width="130px" class="text-right">{{$t('government_fee')}}</th>
              <th width="130px" class="text-right">{{$t('third_party_fee')}}</th>
              <th width="130px" class="text-right">{{$t('savings')}}</th>
              <th width="350px">{{$t('description')}}</th>
              <th width="200px">{{$t('regulation')}}</th>
              <th width="150px">{{$t('frequency')}}</th>
              <th width="350px">{{$t('tacna_responsibility')}}</th>
              <th width="350px">{{$t('client_responsibility')}}</th>
              <th width="100px">{{$t('actions')}}</th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <cell-input
                  class="text-left"
                  :value="data[indextr].client_name"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <cell-input
                  class="text-left"
                  :value="data[indextr].category_name"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <cell-input
                  class="text-left"
                  :value="data[indextr].type_name"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <cell-select
                  @update="updateCell"
                  :id="data[indextr].id"
                  column="building_number"
                  :items="facilities.filter(item => item.client_id == data[indextr].client_id)"
                  :value="{value:data[indextr].building_number,label:data[indextr].building_number}"
                  :keys="{value:'name',label:'name'}"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditing"
                />

                <cell-input
                  class="text-left"
                  :value="data[indextr].name"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <cell-input
                  class="text-center"
                  :value="data[indextr].status_ehs"
                  :bgColor="data[indextr].status_color"
                  :icon="data[indextr].soon_expired ? 'AlertTriangleIcon': null"
                  :iconTextColor="data[indextr].soon_expired ?'text-primary': null"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <cell-input
                  class="text-left comment-truncate"
                  :value="data[indextr].observations"
                  :id="data[indextr].id"
                  column="observations"
                  @update="updateCell"
                  :max="100"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditing"
                />

                <cell-action
                  class="cursor-pointer text-left"
                  :disabled="!allowEditing"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                >
                  <template>
                    <div
                      @click="updateExpiration(data[indextr])"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                    >{{ data[indextr].date_expiration !== '1900-01-01' ?  formatDate(data[indextr].date_expiration) : '-'}}</div>
                  </template>
                </cell-action>

                <cell-date
                  class="text-left"
                  :value="data[indextr].activity_startdate ? formatDate(data[indextr].activity_startdate):null"
                  :id="data[indextr].id"
                  column="activity_startdate"
                  @update="updateCell"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditingStartDate"
                />

                <cell-input
                  class="text-left"
                  type="number"
                  format="number"
                  :value="data[indextr].activity_duration"
                  :id="data[indextr].id"
                  column="activity_duration"
                  @update="updateCell"
                  :max="3"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditing"
                />

                <cell-input
                  class="text-right"
                  type="number"
                  format="decimal"
                  :value="data[indextr].government_fee"
                  :id="data[indextr].id"
                  column="government_fee"
                  @update="updateCell"
                  :max="11"
                  prefix="$"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditing"
                />

                <cell-input
                  class="text-right"
                  type="number"
                  format="decimal"
                  :value="data[indextr].cost"
                  :id="data[indextr].id"
                  column="cost"
                  @update="updateCell"
                  :max="11"
                  prefix="$"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditing"
                />

                <cell-input
                  class="text-right"
                  type="number"
                  format="decimal"
                  :value="data[indextr].savings"
                  :id="data[indextr].id"
                  column="savings"
                  @update="updateCell"
                  :max="11"
                  prefix="$"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditing"
                />

                <cell-input
                  class="text-left"
                  :value="data[indextr].third"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <cell-input
                  class="text-left"
                  :value="data[indextr].regulation"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <!-- <cell-select
                  @update="updateCell"
                  :id="data[indextr].id"
                  column="frequency"
                  :items="frequencies"
                  :value="{value:data[indextr].frequency,label:data[indextr].frequency}"
                  :keys="{value:'name',label:'name'}"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditing"
                /> -->

                <cell-select
                  @update="updateCell"
                  :id="data[indextr].id"
                  column="frequency"
                  :items="frequencies"
                  :value="{value:data[indextr].frequency_id,label:data[indextr].frequency_name}"
                  :keys="{value:'name',label:'name'}"
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  :disabled="!allowEditing"
                />



                <cell-input
                  class="text-left"
                  :value="data[indextr].responsibility_tacna"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <cell-input
                  class="text-left"
                  :value="data[indextr].responsibility_customer"
                  disabled
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                />

                <cell-action
                  :tooltip-text="`${data[indextr].building_number} - ${data[indextr].client_name}`"
                  disabled
                  class="text-center"
                >
                  <template>
                    <feather-icon
                      @click="showPdf(data[indextr].file,`${data[indextr].building_number} - ${data[indextr].client_name}`)"
                      icon="FileTextIcon"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      v-if="data[indextr].file !== ''"
                    />
                    <delete-button-custom :id="data[indextr].id" v-if="hasPermission(['IU EHS DELETE'])"/>
                  </template>
                </cell-action>
              </vs-tr>
              <vs-tr>
                <vs-td colspan="100%">
                  <div
                        v-if="data.length"
                        v-observe-visibility="infiniteHandler"
                      ></div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          </div>
        </vs-row>
      </vx-card>
    </div>
  
  </div>
</template>

<script>
import moduleEhs from '@/store/ehs/moduleEhs.js'
import AddEhs from '@/views/apps/ehs/AddEhs.vue'
import UpdateEhsExpiration from '@/views/apps/ehs/UpdateEhsExpiration.vue'
import CellInput from '@/components/cell-edit/CellInput.vue'
import CellDate from '@/components/cell-edit/CellDate.vue'
import CellSelect from '@/components/cell-edit/CellSelect.vue'
import CellAction from '@/components/cell-edit/CellAction.vue'
import DeleteButtonCustom from './DeleteButtonCustom.vue'
import PdfViewer from '@/components/pdf/PdfViewer.vue'

import vSelect from 'vue-select'
import { BASE_URL, URL_EXPORT_CSV, URL_CUSTOM_REPORT } from '@/urls.js'

import client from '@/http/requests/client'
import category from '@/http/requests/category'
import internalPortal from '@/http/requests/internalPortal'
import ExportButton from '@/views/components/ExportButton.vue'
import ehsCatalog from '@/http/requests/ehsCatalog'
import ehs from '@/http/requests/ehs'
import general from '@/http/requests/general'

import AddButton from '@/views/components/buttons/AddButton.vue'
export default {
  components: {
    AddEhs,
    UpdateEhsExpiration,
    CellInput,
    CellDate,
    CellSelect,
    CellAction,
    DeleteButtonCustom,
    PdfViewer,
    ExportButton,
    'v-select': vSelect,
    AddButton
  },
  data() {
    const sortOrders = {}
    const columnas = [
      'Cl.ClientName',
      'Category.name',
      'ehns.building_number',
      'ehns.name',
      'Status.id',
      'ehns.date_expiration',
      'ehns.date_expedition'
    ]
    columnas.forEach(function (key) {
      sortOrders[key] = 1
    })
    return {
      ehs: null,
      lastPage:1,
      params: {
        page: 1,
        search: ' ',//this space on the string is necessary for de CSV Export, DO NOT DELETE IT
        sortBy: ['ehns.created_at'],
        sort: ['desc']
      },
      clients: [],
      categories: [],
      catalogs: [],
      frequencies: [],
      facilities: [],
      types:[],
      url: '',
      name_report: 'none',
      sortOrders,
      clientFilter: [],
      statusFilter: [],
      categoryFilter: [],
      allowEditing:false,
      allowEditingStartDate:false,
      showAlert:false,
      soonToExpired:0
    }
  },
  computed: {
    ehsList() {
      return this.$store.state.ehs.ehsList
    },
    filters() {
      return this.$store.state.filters
    },
    redirectFilter() {
      return this.$store.state.filter
    },
    currentFilter() { return this.$store.state.filterEhs },
    statusFilterState() { return this.$store.state.statusEhsSelect },
    allowed_to_see_module() {
      let allowed = localStorage.getItem('permissions').includes('IU EHS Module')
      return allowed
    }
  },
  created() {
    if (!moduleEhs.isRegistered) {
      this.$store.registerModule('ehs', moduleEhs)
      moduleEhs.isRegistered = true
    }
  },
  watch: {
    currentFilter: function () {
      this.resetFilters()
      this.params.status_id = this.currentFilter ? [this.currentFilter] : null
      this.search()
    }
  },
  beforeMount() {
    this.$store.dispatch('clearGlobalComplianceFilter')
  },
  mounted() {
    this.allowEditing = this.hasPermission(['IU EHS EDIT'])
    this.allowEditingStartDate = this.hasPermission(['IU EDIT START DATE'])
    this.params.status_id = this.currentFilter ? [this.currentFilter] : null
    //this.getEhsCatalog()
    this.getFrequencies()
    this.getFacilities()
    this.getTypes()
    this.getClients()
    this.getCategories()
    this.getSoonToExpired()
  
    if(Object.entries(this.redirectFilter).length !== 0){
      this.params.search = this.redirectFilter.item.id
      this.params.client_id = [this.redirectFilter.item.client_id]
    }  
    this.search()
  },
  methods: {
    getCategories(){
      category.list()
        .then(res => {
          this.categories = res.data.categories
          this.categoryFilter.push(...res.data.categories)
        })
    },
    getClients(){
      client.listToEhsSelect()
      .then(res => {
        this.clients = res.data.clients
        this.clientFilter.push(...res.data.clients)
        
      })
    },
    getEhsCatalog() {
      ehsCatalog.getCatalog({}).then(res => {
        this.catalogs = res.data.catalogs
      });
    },
    getFrequencies() {
      general.frequencies().then(res => {
        this.frequencies = res.data.frequencies
      });
    },
    getFacilities() {
      ehs.getFacilities().then(res => {
        this.facilities = res.data.facilities
      });
    },
    getTypes() {
      ehs.getTypes().then(res => {
        this.types = res.data.types
      });
    },
    filter(array, key, value) {
      return array.filter(item => item[key] == value)
    },
    updateCell(e) {
      this.$store.dispatch('ehs/updateEhs', e)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: 'Updated',
            text: 'Success'
          })
        })
        .catch(err => {
          if (err.response.status === 422) {
            const error = err.response.data.errors[e.column][0]
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: error
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: 'Server Error'
            })
          }
        })
    },
    addEhs() {
        if(this.allowEditing){
      this.$store.dispatch('toggleSidebar', 'addEhs')
      }
    },
    updateExpiration (ehs) {
      if(this.allowEditing){
        this.ehs = { id: ehs.id, date_expiration: ehs.date_expiration }
        this.$store.dispatch('toggleSidebar','updateEhsExpiration')
      }
    },
    search(sortBy = 'ehns.name') {
      this.topTableScroll()
      let sort = 'asc'
      if (sortBy == this.params.sortBy) {
        if (this.params.sort[0] == 'asc') {
          sort = 'desc'
        }
      }
      this.params.page = 1
      this.params.sortBy = [sortBy]
      this.params.sort = [sort]

      for (var propName in this.params) {
        if (this.params[propName] === null || this.params[propName] === undefined || this.params[propName].length === 0) {
          delete this.params[propName];
        }
      }
     
      //revisar despues
      this.getEhsList()
        .then(res => {
          this.closeLoading()
          if(Object.entries(this.redirectFilter).length !== 0){
            this.params.search = ''
            this.params.client_id = []
            this.$store.dispatch('setFilter',{});
          }  
        })
        .catch(err =>
          this.closeLoading()
        )
    },
    getEhsList() {
      this.openLoading()
      return this.$store.dispatch('ehs/fetchEhsList', this.params).then(res => {
        this.lastPage = res.data.last_page
      })
    },
    infiniteHandler(isVisible) {
      if (!isVisible) { return }
      if (this.params.page >= this.lastPage) { return }
      this.params.page++
      this.getEhsList()
        .then(res => { this.closeLoading() })
        .catch(err => { this.closeLoading() })
    },
    openLoading() {
      this.$vs.loading({
        container: '#ehs-list-loading',
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close('#ehs-list-loading > .con-vs-loading')
    },
    sortBy(key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
    },
    showPdf:function(src, title) {
      if (src) {
        this.$store.dispatch('togglePdfViewer', { active: true, src: BASE_URL + 'storage/' + src,title})
      } else {
        this.$vs.notify({
          color: 'warning',
          title: 'Not File attached',
          text: 'Not File attached'
        })
      }
    },
    resetFilters() {
      this.params.category_id = []
      this.params.status_id = []
      this.params.client_id = []
      this.params.type_id = []
      this.search()
    },
    topTableScroll(){
      let elemento = document.getElementsByClassName('vs-con-tbody vs-table--tbody');
      elemento[0].scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    },
    getSoonToExpired(){
      ehs.getSoonToExpired()
      .then((res) => {
        this.soonToExpired = Number(res.data.item[0].total)
        this.showAlert = this.soonToExpired > 0
      })
    }
  }
}
</script>
<style>
.vs-con-table .vs-con-tbody {
  /* height: 80vh;
  width: calc(100vw - 160px); */
  overflow: auto;
}
.fixedHead table {
  /*width: 2500px; */
  table-layout: fixed;
}
.fixedHead table th {
  min-width: 100px;
  cursor: pointer;
}

.fixedHead table thead th:not([scope="row"]) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
}

.vx-card__body {
  padding: 10px 0px !important;
}

.vs-table--not-data {
  display: none !important;
}

.sm-size {
  font-size: 12px;
}

.comment-truncate {
  overflow-wrap: break-word;
}
.vx-card__title h4 {
  margin-bottom: 2vh;
}
</style>